import React from "react";
import { Form } from "react-bootstrap";
import InputMask from "react-input-mask";
import PhoneInput from "../phone-input.component.tsx";

const UserDataFormField = ({ translate, value, onChange, setIsLoading, config, isInvalid = false, formData, setUserData }) => {
    const handleAction = async (event) => {
        if (config.action && config.action.when === event._reactName) {
            setIsLoading(true);
            const response = await config.action.method(value);
            setIsLoading(false);
            if (config.action.fillUp && typeof response === "object") {
                Object.keys(config.action.fillUp).forEach((key) => {
                    setUserData(key, response[config.action.fillUp[key]]);
                })
            }
        }
    };

    return (
        <>
            {config.phone ? (
                <Form.Group>
                    <Form.Label className="mb-0" style={{ fontSize: 12 }}>{translate(config.label)}</Form.Label>
                    <PhoneInput
                        value={value}
                        onChange={onChange}
                        isInvalid={isInvalid}
                        config={config}
                        translate={translate}
                        required={config.required}
                    />
                    {config.helpBlock && (
                        <Form.Control.Feedback type="invalid" id={translate(config.ariaDescribedby)}>
                            {translate(config.helpBlock)}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
            ) : !config.mask ? (
                <Form.Group>
                    <Form.Label className="mb-0" style={{ fontSize: 12 }}>{translate(config.label)}</Form.Label>
                    <Form.Control
                        type={config.fieldType || "text"}
                        maxLength={config.maxLength || 127}
                        placeholder={translate(config.placeholder)}
                        className={`${config.className} mb-2`}
                        autoComplete="off"
                        aria-describedby={translate(config.ariaDescribedby)}
                        value={value}
                        onChange={onChange}
                        onBlur={handleAction}
                        isInvalid={isInvalid}
                        required={config.required}
                    />
                    {config.helpBlock && (
                        <Form.Control.Feedback type="invalid" id={translate(config.ariaDescribedby)}>
                            {translate(config.helpBlock)}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
            ) : (
                <Form.Group>
                    <Form.Label className="mb-0" style={{ fontSize: 12 }}>{translate(config.label)}</Form.Label>
                    <InputMask
                        mask={config.mask}
                        value={value}
                        onChange={onChange}
                        onBlur={handleAction}
                    >
                        {(inputProps) => (
                            <Form.Control
                                {...inputProps}
                                type={config.fieldType || "text"}
                                placeholder={translate(config.placeholder)}
                                className={`${config.className} mb-2`}
                                autoComplete="off"
                                aria-describedby={translate(config.ariaDescribedby)}
                                isInvalid={isInvalid}
                                required={config.required}
                            />
                        )}
                    </InputMask>
                    {config.helpBlock && (
                        <Form.Control.Feedback type="invalid" id={translate(config.ariaDescribedby)}>
                            {translate(config.helpBlock)}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
            )}
        </>
    );
};

export default UserDataFormField;
